import { PrimaryButton } from "@fluentui/react";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import React from "react";
import { useSessions } from "../../Hooks";
import { SessionData, SessionsPageProps } from "../../Interfaces";
import { sessionClassNames as classNames, sessionStyles as styles } from "../../Styles";
import { SessionsPanel } from "./SessionsPanel";
import { SessionsTable } from "./SessionsTable";
import { logEvent } from "../../../../helper/AppInsightsHelper";

export const SessionsPage: React.FC<SessionsPageProps> = (props) => {
  const {
    rows,
    enablePanel,
    selectedRowData,
    isSessionDataEditable,
    setIsSessionDataEditable,
    isSessionModified,
    setIsSessionModified,
    savedStatus,
    deleteStatus,
    bulkUpdateStatus,
    selectedForDeletion,
    setSelectedForDeletion,
    handleFieldChange,
    handleRunClick,
    handleDeleteButtonClick,
    handleOnChangeSessionData,
    handleBulkUpdate,
    handleDismissPanel,
    handleOpenSessionsPanel,
    handleSaveButtonClick
  } = useSessions({ onRunPrompt: props.onRunPrompt });

  React.useEffect(() => {
    setSelectedForDeletion([]); // reset on page load
    setIsSessionModified(false); // reset session modified state
    logEvent("My Sessions Page Opened", "AI Hub - KQL Mode", "SessionsPage");
  }, []);

  return (
    <>
      <div className={classNames.sessionsTableStyles}>
        <SessionsTable
          rows={rows ?? []}
          onFieldChange={handleFieldChange}
          openSessionPanel={handleOpenSessionsPanel}
          selectedForDeletion={selectedForDeletion}
        />
      </div>
      <div className={classNames.saveSessionButtonStyles}>
        <PrimaryButton
          iconProps={{ iconName: "Save" }}
          styles={styles.buttonStyles}
          onClick={() => handleBulkUpdate()}
          disabled={!isSessionModified || bulkUpdateStatus.isBulkUpdating || bulkUpdateStatus.isBulkUpdated || rows?.length === 0}
        >
          {(() => {
            if (bulkUpdateStatus.isBulkUpdating)
              return (
                <>
                  <span style={{ marginRight: 8 }}>Saving</span>
                  <Spinner size={SpinnerSize.xSmall} />
                </>
              );
            if (bulkUpdateStatus.isBulkUpdated) return <>Saved successfully</>;
            return <>Save Changes</>;
          })()}
        </PrimaryButton>
      </div>
      <SessionsPanel
        onFieldUpdate={(field: keyof SessionData, value: string | boolean) => handleOnChangeSessionData(field, value)}
        onSaveButtonClick={handleSaveButtonClick}
        onDeleteButtonClick={handleDeleteButtonClick}
        onClosePanel={handleDismissPanel}
        handleEditSession={() => setIsSessionDataEditable(!isSessionDataEditable)}
        handleRunClick={handleRunClick}
        openPanel={enablePanel}
        selectedRowData={selectedRowData}
        isSessionDataEditable={isSessionDataEditable}
        isSaved={savedStatus.isSaved}
        isSaving={savedStatus.isSaving}
        deleted={deleteStatus.deleted}
        isDeleting={deleteStatus.isDeleting}
      />
    </>
  );
};
